import React from "react";
import AdminCoupons from "../../components/AdminCoupons/AdminCoupons";
import Footer from "../../common/Footer/Footer";
import UserPage from "../../common/UserPage/UserPage";

const AdminCouponsPage = () => {
  return (
    <div>
      <UserPage />
      <AdminCoupons />
      <Footer />
    </div>
  );
};

export default AdminCouponsPage;
